module.exports = __webpack_public_path__ + "img/gun-turret-gun-2.93269f8c.png";